import { MaterialCommunityIcons } from "@expo/vector-icons";
import React, { useEffect, useState } from "react";
import { View, StyleSheet, Text, FlatList, Platform, TouchableOpacity } from 'react-native'
import * as Linking from 'expo-linking';
import Svg, {Path} from 'react-native-svg'
import { responsiveFontSize } from "react-native-responsive-dimensions";
import Header from "../components/header";
import colors from "../styles/colors";
import MyText from "../components/MyText";

const pathPix = "M242.4 292.5c5.4-5.4 14.7-5.4 20.1 0l77 77c14.2 14.2 33.1 22 53.1 22h15.1l-97.1 97.1c-30.3 29.5-79.5 29.5-109.8 0l-97.5-97.4h9.3c20 0 38.9-7.8 53.1-22l76.7-76.7zm20.1-73.6c-6.4 5.5-14.6 5.6-20.1 0l-76.7-76.7c-14.2-15.1-33.1-22-53.1-22h-9.3l97.4-97.44c30.4-30.346 79.6-30.346 109.9 0l97.2 97.14h-15.2c-20 0-38.9 7.8-53.1 22l-77 77zm-149.9-76.2c13.8 0 26.5 5.6 37.1 15.4l76.7 76.7c7.2 6.3 16.6 10.8 26.1 10.8 9.4 0 18.8-4.5 26-10.8l77-77c9.8-9.7 23.3-15.3 37.1-15.3h37.7l58.3 58.3c30.3 30.3 30.3 79.5 0 109.8l-58.3 58.3h-37.7c-13.8 0-27.3-5.6-37.1-15.4l-77-77c-13.9-13.9-38.2-13.9-52.1.1l-76.7 76.6c-10.6 9.8-23.3 15.4-37.1 15.4H80.78l-58.02-58c-30.346-30.3-30.346-79.5 0-109.8l58.02-58.1h31.82z"

export default function Info({navigation, route}){
    const[business, setBusiness] = useState(null)
    const[listServices, setListServices] = useState(null)
    useEffect(()=>{
        const {listServices, business} = route.params;
        setBusiness(business)
        setListServices(listServices)
    },[])

    function convertWeekDay(week){
        let day = [
            'Domingo',
            'Segunda-feira',
            'Terça-feira',
            'Quarta-feira',
            'Quinta-feira',
            'Sexta-feira', 
            'Sábado'
        ]
        return day[week];
    }

    function formatTime(item){
        let time = ''
        if(item.to !== '00:00' && item.from !== '00:00' && item.to2 !== '00:00' && item.from2 !== '00:00'){
            time = `${item.from} - ${item.to} e ${item.from2} - ${item.to2}`
        }else{
            time = `${item.from} - ${item.to}`
        }
        return time
    }

    function openMaps(){
        const { lat, long} = business.endereco;
        const scheme = Platform.select({ ios: 'maps:0,0?q=', android: 'geo:0,0?q=', web: 'https://maps.google.com/?q='});
        const latLng = `${lat},${long}`;
        const url = Platform.select({
            ios: `${scheme}${latLng}`,
            android: `${scheme}${latLng}`,
            web: `${scheme}${latLng}`
        });


        Linking.openURL(url); 
    }

    function renderHorario(item){
        return(
            <View style={styles.containerItemHorario}>
                <MyText style={styles.subText}>{convertWeekDay(item.week_day)}</MyText>
                {item.checked === true ? (
                    <MyText style={styles.subText}>{formatTime(item)}</MyText>
                ) : (
                    <MyText style={styles.closed}>Fechado</MyText>
                )}
            </View>
        )
    }

    function renderPayment(item){
        return(
            <View style={{flexDirection: 'row'}}>
                {item.method !== "Pix" ? (
                    <MaterialCommunityIcons style={{marginRight: responsiveFontSize(1)}} name={item.method === 'Cartão' ? "credit-card-outline" : "cash"} size={responsiveFontSize(2)} color="gray" />
                ) : (
                    <Svg
                        xmlns="http://www.w3.org/2000/svg"
                        height={responsiveFontSize(1.7)}
                        viewBox="0 0 512 512"
                        style={{marginRight: responsiveFontSize(1.3)}}
                        >
                        <Path d={pathPix} fill={'gray'} />
                    </Svg>
                )}
                <MyText style={styles.subText}>{item.method}</MyText>
            </View>
        )
    }
    return(
        <View style={styles.container}>
            <Header business={business}/>
            <MyText style={[styles.title,{marginTop: responsiveFontSize(5)}]}>Horário de funcionamento</MyText>
            {business !== null && (
                <FlatList
                    data={business.horario}
                    keyExtractor={item => item.week_day}
                    renderItem={({item}) => renderHorario(item)}
                    style={styles.list}
                />
            )}
            <MyText style={styles.title}>Tipo de Serviço</MyText>
            <MyText style={styles.subText}>{listServices}</MyText>
            <MyText style={styles.title}>Método de pagamento</MyText>
            {business !== null && (
                <FlatList
                    data={business.typeOfPayment}
                    keyExtractor={(item,index) => index}
                    renderItem={({item}) => renderPayment(item)}
                    style={styles.listPayment}
                />
            )}
            <MyText style={styles.title}>Endereço</MyText>
            <View style={styles.horizontal}>
                <View>
                    <MyText style={styles.subText}>{`${business?.endereco.rua}, ${business?.endereco.numero}, ${business?.endereco.bairro}`}</MyText>
                    <MyText style={styles.subText}>{business?.endereco.referencia}</MyText>
                </View>
                <TouchableOpacity style={styles.btnMapa} onPress={()=>{openMaps()}}>
                    <MaterialCommunityIcons name="google-maps" size={responsiveFontSize(3)} color={colors.red} />
                    <MyText style={styles.btnMapaTxt}>Ver no Mapa</MyText>
                </TouchableOpacity>
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        width: responsiveFontSize(49),
        height: '100%',
        backgroundColor: 'white',
        paddingHorizontal: responsiveFontSize(1),
    },
    title: {
        fontSize: responsiveFontSize(1.5),
        fontWeight: 'bold',
        marginVertical: responsiveFontSize(1)
    },
    subText: {
        fontSize: responsiveFontSize(1.5),
        color: colors.gray2
    },
    //array horario
    containerItemHorario: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    list: {
        maxHeight: responsiveFontSize(15)
    },
    closed: {
        color: colors.red,
        fontSize: responsiveFontSize(1.5),
    },
    listPayment: {
        maxHeight: responsiveFontSize(7)
    },
    //btn enderreco
    horizontal: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    btnMapa: {
        paddingHorizontal: responsiveFontSize(0.5),
        alignItems: 'center'
    },
    btnMapaTxt: {
        fontSize: responsiveFontSize(1)
    }
})